export const URLS = {
  companies: {
    all: "companies/",
    create: "companies/",
    update: (companyId: string) => `companies/${companyId}/`,
  },
  jobs: {
    activity: {
      file: (jobId: string) => `jobs/${jobId}/activity/form/file/`,
    },
    all: "jobs/",
    detail: (jobId: string) => `jobs/${jobId}/`,
    update: (jobId: string) => `jobs/${jobId}/`,
    updateSchedule: (jobId: string) => `jobs/${jobId}/reschedule/`,
    cancel: (jobId: string) => `jobs/${jobId}/cancel/`,
    failedVisit: (jobId: string) => `jobs/${jobId}/failed-visit/`,
    pdf: {
      download: (jobId: string) => `jobs/${jobId}/pdf/`,
      generate: (jobId: string) => `jobs/${jobId}/pdf/`,
    },
    skills: {
      all: "jobs/skills/",
      create: "jobs/skills/",
      update: (skillSlug: string) => `jobs/skills/${skillSlug}/`,
    },
    statusList: "jobs/status/",
    types: {
      activities: {
        all: (jobTypeId: string) => `jobs/types/${jobTypeId}/activities/`,
        create: (jobTypeId: string) => `jobs/types/${jobTypeId}/activities/`,
        detail: (jobTypeId: string, activityId: string) =>
          `jobs/types/${jobTypeId}/activities/${activityId}/`,
        update: (jobTypeId: string, activityId: string) =>
          `jobs/types/${jobTypeId}/activities/${activityId}/`,
      },
      all: "jobs/types/",
      create: "jobs/types/",
      detail: (jobTypeId: string) => `jobs/types/${jobTypeId}/`,
      pdfSettings: {
        update: (jobTypeId: string) => `jobs/types/${jobTypeId}/pdf/settings/`,
      },
      update: (jobTypeId: string) => `jobs/types/${jobTypeId}/`,
    },
    workers: "jobs/schedule/",
  },
  tenants: {
    all: "tenants/",
    create: "tenants/",
    update: (tenantId: string) => `tenants/${tenantId}/`,
  },
  users: {
    all: "users/",
    create: "users/",
    update: (userId: string) => `users/${userId}/`,
  },
  forms: {
    all: "jobs/forms/",
    create: "jobs/forms/",
    update: (formId: string) => `jobs/forms/${formId}/`,
    detail: (formId: string) => `jobs/forms/${formId}/`,
    formFields: {
      create: (formId: string) => `jobs/forms/${formId}/fields/`,
      sort: (formId: string) => `jobs/forms/${formId}/fields/sort/`,
      update: (formId: string, fieldId: string) =>
        `jobs/forms/${formId}/fields/${fieldId}/`,
    },
  },
};
